import { Box, Skeleton, Typography } from '@mui/material';
import {
  keywordOverviewCss,
  KeywordOverviewResultCardsCss
} from '../keywordResearch/keywordOverview/keywordOverviewCSS';
import {
  CompetitorAnalysisResultCardsTexts,
  competitorAnalysisToolTipTexts
} from 'src/common/config/TextMessage';
import { keywordResearchDashBoardCss } from '../keywordResearch/keywordResearchCSS';
import { CustomTooltip } from '../keywordResearch/CustomTooltip';
import HelpIcon from '@mui/icons-material/Help';
import { formatNumberWithCommas } from 'src/common/config/FunctionHelper';
import { BackLinkAllTexts } from './BackLinkAllTexts';

export const BackLinkCards = ({ cardData, loader }) => {
  return (
    <>
      <Box
        sx={{
          ...KeywordOverviewResultCardsCss?.mainCardsBox
        }}
      >
        <Box sx={KeywordOverviewResultCardsCss?.subBoxes}>
          {loader ? (
            <Box>
              <Skeleton
                variant="rectangular"
                animation="wave"
                height={20}
                sx={keywordOverviewCss?.cardSkeleton}
              />
              <Skeleton
                variant="rectangular"
                animation="wave"
                height={20}
                sx={keywordOverviewCss?.cardSkeleton}
              />
            </Box>
          ) : (
            <Box>
              <Box sx={KeywordOverviewResultCardsCss?.subBoxHeader}>
                <Typography sx={KeywordOverviewResultCardsCss?.subHeaderFont}>
                  {CompetitorAnalysisResultCardsTexts?.domainAuthority}
                </Typography>
                <CustomTooltip
                  title={
                    <Box>
                      <Typography
                        sx={keywordResearchDashBoardCss?.customTollTipText}
                      >
                        <span
                          style={
                            keywordResearchDashBoardCss?.customTollTipTextDark
                          }
                        >
                          {competitorAnalysisToolTipTexts?.domainAuthorityHead}
                        </span>
                        {competitorAnalysisToolTipTexts?.domainAuthority}
                      </Typography>
                    </Box>
                  }
                  placement="bottom"
                  arrow
                >
                  <HelpIcon sx={KeywordOverviewResultCardsCss?.helpIcon} />
                </CustomTooltip>
              </Box>
              <Box sx={KeywordOverviewResultCardsCss?.keywordNumBox}>
                <Typography sx={KeywordOverviewResultCardsCss?.keywordNum}>
                  {cardData && cardData?.domainAuthority
                    ? formatNumberWithCommas(cardData?.domainAuthority)
                    : 0}
                </Typography>
              </Box>
            </Box>
          )}
        </Box>
        <Box sx={KeywordOverviewResultCardsCss?.subBoxes}>
          {loader ? (
            <Box>
              <Skeleton
                variant="rectangular"
                animation="wave"
                height={20}
                sx={keywordOverviewCss?.cardSkeleton}
              />
              <Skeleton
                variant="rectangular"
                animation="wave"
                height={20}
                sx={keywordOverviewCss?.cardSkeleton}
              />
            </Box>
          ) : (
            <Box>
              <Box sx={KeywordOverviewResultCardsCss?.subBoxHeader}>
                <Typography sx={KeywordOverviewResultCardsCss?.subHeaderFont}>
                  {CompetitorAnalysisResultCardsTexts?.backlinks}
                </Typography>
                <CustomTooltip
                  title={
                    <Box>
                      <Typography
                        sx={keywordResearchDashBoardCss?.customTollTipText}
                      >
                        <span
                          style={
                            keywordResearchDashBoardCss?.customTollTipTextDark
                          }
                        >
                          {CompetitorAnalysisResultCardsTexts?.backlinks}
                        </span>
                        {competitorAnalysisToolTipTexts?.backLinks}
                      </Typography>
                    </Box>
                  }
                  placement="bottom"
                  arrow
                >
                  <HelpIcon sx={KeywordOverviewResultCardsCss?.helpIcon} />
                </CustomTooltip>
              </Box>
              <Box
                sx={{
                  ...KeywordOverviewResultCardsCss?.backLinkBoxSx,
                  ...KeywordOverviewResultCardsCss?.keywordNumBox
                }}
              >
                <Typography sx={KeywordOverviewResultCardsCss?.keywordNum}>
                  {cardData && cardData?.totalBackLinks
                    ? formatNumberWithCommas(cardData?.totalBackLinks)
                    : 0}
                  {/* {CompetitorAnalysisResultCardsTexts?.numFour} */}
                </Typography>
              </Box>
            </Box>
          )}
        </Box>
        <Box sx={KeywordOverviewResultCardsCss?.subBoxes}>
          {loader ? (
            <Box>
              <Skeleton
                variant="rectangular"
                animation="wave"
                height={20}
                sx={keywordOverviewCss?.cardSkeleton}
              />
              <Skeleton
                variant="rectangular"
                animation="wave"
                height={20}
                sx={keywordOverviewCss?.cardSkeleton}
              />
            </Box>
          ) : (
            <Box>
              <Box sx={KeywordOverviewResultCardsCss?.subBoxHeader}>
                <Typography sx={KeywordOverviewResultCardsCss?.subHeaderFont}>
                  {CompetitorAnalysisResultCardsTexts?.estimatedOrganicTraffic}
                </Typography>
                <CustomTooltip
                  title={
                    <Box>
                      <Typography
                        sx={keywordResearchDashBoardCss?.customTollTipText}
                      >
                        <span
                          style={
                            keywordResearchDashBoardCss?.customTollTipTextDark
                          }
                        >
                          {
                            CompetitorAnalysisResultCardsTexts?.estimatedOrganicTraffic
                          }
                        </span>
                        {BackLinkAllTexts?.organicTrafficTooltip}
                      </Typography>
                    </Box>
                  }
                  placement="bottom"
                  arrow
                >
                  <HelpIcon sx={KeywordOverviewResultCardsCss?.helpIcon} />
                </CustomTooltip>
              </Box>
              <Box sx={KeywordOverviewResultCardsCss?.keywordNumBox}>
                <Typography sx={KeywordOverviewResultCardsCss?.keywordNum}>
                  {cardData && cardData?.organicTraffic
                    ? formatNumberWithCommas(cardData?.organicTraffic)
                    : 0}
                  {/* {CompetitorAnalysisResultCardsTexts?.numOne} */}
                </Typography>
              </Box>
            </Box>
          )}
        </Box>
        <Box sx={KeywordOverviewResultCardsCss?.subBoxes}>
          {loader ? (
            <Box>
              <Skeleton
                variant="rectangular"
                animation="wave"
                height={20}
                sx={keywordOverviewCss?.cardSkeleton}
              />
              <Skeleton
                variant="rectangular"
                animation="wave"
                height={20}
                sx={keywordOverviewCss?.cardSkeleton}
              />
            </Box>
          ) : (
            <Box>
              <Box sx={KeywordOverviewResultCardsCss?.subBoxHeader}>
                <Typography sx={KeywordOverviewResultCardsCss?.subHeaderFont}>
                  {CompetitorAnalysisResultCardsTexts?.totalKeywords}
                </Typography>
                <CustomTooltip
                  title={
                    <Box>
                      <Typography
                        sx={keywordResearchDashBoardCss?.customTollTipText}
                      >
                        <span
                          style={
                            keywordResearchDashBoardCss?.customTollTipTextDark
                          }
                        >
                          {CompetitorAnalysisResultCardsTexts?.totalKeywords}
                        </span>
                        {competitorAnalysisToolTipTexts?.totalKeywords}
                      </Typography>
                    </Box>
                  }
                  placement="bottom"
                  arrow
                >
                  <HelpIcon sx={KeywordOverviewResultCardsCss?.helpIcon} />
                </CustomTooltip>
              </Box>
              <Box sx={KeywordOverviewResultCardsCss?.keywordNumBox}>
                <Typography sx={KeywordOverviewResultCardsCss?.keywordNum}>
                  {cardData && cardData?.totalKeywords
                    ? formatNumberWithCommas(cardData?.totalKeywords)
                    : 0}
                  {/* {CompetitorAnalysisResultCardsTexts?.numTwo} */}
                </Typography>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};
